import { Nav } from "react-bootstrap";
import "./sidebar.scss";

const Sidebar = ({children, defaultActiveKey}) => {


    return (
        <aside className="sidebar col-auto p-1 py-3 py-md-5">
            <Nav className="flex-column justify-content-center my-4" defaultActiveKey={defaultActiveKey} >
                {children}
            </Nav>
        </aside>
    );
}

export default Sidebar;